import { Controller } from 'react-hook-form'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.tsx'
import { DailyRepetitionSelector } from '@/modules/tasks/components/task-scheduler-dialog/daily-repetition-selector.tsx'
import { MonthlyRepetitionSelector } from '@/modules/tasks/components/task-scheduler-dialog/monthly-repetition-selector.tsx'
import { WeeklyRepetitionSelector } from '@/modules/tasks/components/task-scheduler-dialog/weekly-repetition-schedule.tsx'
import { YearlyRepetitionSelector } from '@/modules/tasks/components/task-scheduler-dialog/yearly-repetition-selector.tsx'

export const RepetitionSelector = () => {
  return (
    <Controller
      name="period"
      render={({ field }) => (
        <div className="flex flex-col gap-2">
          <label
            htmlFor="assignees"
            className="text-sm font-medium text-title"
          >
            Repetition
          </label>
          <div className="w-[240px]">
            <Select
              value={field.value}
              onValueChange={field.onChange}
            >
              <SelectTrigger>
                <SelectValue className="flex flex-row justify-between" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Daily">Daily</SelectItem>
                <SelectItem value="Weekly">Weekly</SelectItem>
                <SelectItem value="Monthly">Monthly</SelectItem>
                <SelectItem value="Annually">Annually</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {field.value === 'Daily' && <DailyRepetitionSelector />}
          {field.value === 'Weekly' && (
            <WeeklyRepetitionSelector
              name="rateDaysOfWeek"
              entityLabel="Task"
            />
          )}
          {field.value === 'Monthly' && <MonthlyRepetitionSelector />}
          {field.value === 'Annually' && <YearlyRepetitionSelector />}
        </div>
      )}
    />
  )
}
